export const RESOURCE_TYPE_SERVICEDESK_VIRTUAL_AGENT_ONBOARDING =
	'SERVICEDESK_VIRTUAL_AGENT_ONBOARDING';
